/* eslint-disable dot-notation */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import PT from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { FbIcon } from "../../atoms/icons/fb-icon";
import { GplusIcon } from "../../atoms/icons/gplus-icon";
import { TwitterIcon } from "../../atoms/icons/twitter-icon";
import { YoutubeIcon } from "../../atoms/icons/youtube-icon";
import { LinkedinIcon } from "../../atoms/icons/linkedin-icon";
import { InstagramIcon } from "../../atoms/icons/instagram-icon";
import whatsapp  from "../../../../assets/images/whatsapp.svg";
import assetify from "@quintype/framework/assetify";
import podcastIcon from "../../../../assets/images/podcast-solid.svg";
import telegramIcon from "../../../../assets/images/telegram.svg";
import linkedinIcon from "../../../../assets/images/linkedin.svg";
import spotifyIcon from "../../../../assets/images/spotify.svg";
import castBoxIcon from "../../../../assets/images/castbox.svg";
import { FaDiscord } from "react-icons/fa";
import "./social-icons.m.css";

export function SocialIconsBase({
  socialLinks = {},
  showPodcast = false,
  showTelegram = false,
  showLinkedin = false,
  showSpotify = false,
  showCastBox = false,
  showDiscord = false,
  showNewsletter = false,
  showRss = false,
  publisher
}) {
  const [locations, setLocation] = useState("");
  useEffect(() => {
    setLocation(global.location.host);
  }, [locations]);
  const hindi_domain =
    locations === "newslaundry-hindi-web.qtstage.io" ||
    locations === "hindi.newslaundry.com" ||
    locations === "hindi.lvh.me:3000"||
    locations === "hindi.localhost:3000";
  return (
    <ul styleName="social-icons" className="social-icons">
      {socialLinks["facebook-url"] && (
        <li styleName="social-icon">
          <a
            href={
              !hindi_domain
                ? socialLinks["facebook-url"]
                : // eslint-disable-next-line dot-notation
                  publisher["hiFacebook"]
            }
            target="_blank"
            rel="noopener noreferrer"
            styleName="link"
          >
            <FbIcon width={18} height={18} />
          </a>
        </li>
      )}
      {socialLinks["gplus-url"] && (
        <li styleName="social-icon">
          <a
            href={socialLinks["gplus-url"]}
            styleName="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GplusIcon width={18} height={18} />
          </a>
        </li>
      )}
      {socialLinks["twitter-url"] && (
        <li styleName="social-icon">
          <a
            href={
              !hindi_domain
                ? socialLinks["twitter-url"]
                : publisher["hiTwitter"]
            }
            styleName="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <TwitterIcon width={18} height={18} />
          </a>
        </li>
      )}
      {socialLinks["linkedin-url"] && (
        <li styleName="social-icon">
          <a
            href={socialLinks["linkedin-url"]}
            styleName="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkedinIcon width={18} height={18} />
          </a>
        </li>
      )}
      {socialLinks["youtube-url"] && (
        <li styleName="social-icon">
          <a
            href={
              !hindi_domain
                ? socialLinks["youtube-url"]
                : // eslint-disable-next-line dot-notation
                  publisher["hiYoutube"]
            }
            styleName="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <YoutubeIcon width={18} height={18} />
          </a>
        </li>
      )}
      {socialLinks["instagram-url"] && (
        <li styleName="social-icon">
          <a
            href={
              !hindi_domain
                ? socialLinks["instagram-url"]
                : publisher["hiInstagram"]
            }
            styleName="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <InstagramIcon width={18} height={18} />
          </a>
        </li>
      )}
      {/* {hindi_domain &&(
        <li styleName="social-icon">
          <a
            href={
              "/hindi-whatsapp-optin"
            }
            styleName="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={assetify(whatsapp)}
              alt="whatsapp optin"
              width="40px"
              height="40px"
            />
          </a>
        </li>
      )} */}
      {showRss && (
        <li styleName="social-icon">
          <a
            href={
              !hindi_domain
                ? "https://www.newslaundry.com/stories.rss?time-period=last-7-days&exclude-section-ids=15848,15817"
                : "https://www.newslaundry.com/stories.rss?section=newslaundry-hindi&time-period=last-7-days&exclude-section-ids=15848"
            }
            styleName="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://thumbor-stg.assettype.com/newslaundry/2021-07/9c05f502-83c5-4728-a092-d5f51a6a02be/rss_xxl.png"
              alt="rss"
              width="16px"
              height="16px"
            />
          </a>
        </li>
      )}
      {showPodcast && (
        <li styleName="social-icon">
          <a
            href={publisher["applepodcastUrl"]}
            styleName="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={assetify(podcastIcon)}
              alt="apple podcast"
              width="16px"
              height="16px"
            />
          </a>
        </li>
      )}
      {showTelegram && (
        <li styleName="social-icon">
          <a
            href={
              !hindi_domain
                ? publisher["telegramUrl"]
                : publisher["hiTelegramUrl"]
            }
            styleName="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={assetify(telegramIcon)}
              alt="telegram"
              width="16px"
              height="16px"
            />
          </a>
        </li>
      )}
      {showLinkedin && (
        <li styleName="social-icon">
          <a
            href={publisher["linkedinUrl"]}
            styleName="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={assetify(linkedinIcon)}
              alt="linkedin"
              width="16px"
              height="16px"
            />
          </a>
        </li>
      )}
      {showSpotify && (
        <li styleName="social-icon">
          <a
            href={publisher["spotifyUrl"]}
            styleName="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={assetify(spotifyIcon)}
              alt="spotify"
              width="16px"
              height="16px"
            />
          </a>
        </li>
      )}
      {showCastBox && (
        <li styleName="social-icon">
          <a
            href={publisher["castboxUrl"]}
            styleName="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={assetify(castBoxIcon)}
              alt="linkedin"
              width="16px"
              height="16px"
            />
          </a>
        </li>
      )}
      {showDiscord && (
        <li styleName="social-icon">
          <a
            href={
              !hindi_domain ? publisher["discordUrl"] : publisher["hiDiscord"]
            }
            styleName="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaDiscord
              size={"20px"}
              color={"white"}
              width="16px"
              height="16px"
            />
          </a>
        </li>
      )}
      {showNewsletter && (
        <li styleName="social-icon">
          <a
            href="/newsletter-signup"
            styleName="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://img.icons8.com/material-outlined/96/ffffff/email-open.png"
              width="16px"
              height="16px"
            />
          </a>
        </li>
      )}
    </ul>
  );
}

SocialIconsBase.propTypes = {
  socialLinks: PT.object
};

function mapStateToProps(state) {
  return {
    publisher: get(state, ["qt", "config", "publisher", "publisher"], []),
    hindi_domain: get(state, ["qt", "hindi_domain"], null)
  };
}

export const SocialIcons = connect(mapStateToProps)(SocialIconsBase);
